import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSession } from './SessionContext';

// Protected route component that redirects to login if not authenticated
const ProtectedRoute = () => {
  const { isAuthenticated } = useSession();

  // If not authenticated, redirect to login page
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated, render the child routes
  return <Outlet />;
};

export default ProtectedRoute;
